<!-- 调研问卷 -->
<template>
<div>
  <div class="surveyBtn" v-show="axxSurveyShow" @click="axxSurveyClick">
    <div>
      <div class="flex"><img class="surveyIcon" src="https://q-fe.aixuexi.com/cloud/english-word/1724901265550-8e2d8ee38f0c:icon.png" /></div>
      <span class="label">调研问卷</span>
    </div>
  </div>
  <AxxSurvey :position="2" @setAxxSurveyShow="setAxxSurveyShow" ref="axxSurveyRef" />
</div>
</template>
<script>
import AxxSurvey from './survey/index.vue';

export default {
  data() {
    return {
      axxSurveyShow: false,
    };
  },
  components: {
    AxxSurvey,
  },
  mounted() {
    // console.log('this.$refs.axxSurveyRef', this.$refs.axxSurveyRef);
    // if (this.$refs.axxSurveyRef) this.$refs.axxSurveyRef.getDataExternal().then();
  },
  methods: {
    setAxxSurveyShow(val) {
      this.axxSurveyShow = val;
    },
    axxSurveyClick() {
      if (this.$refs.axxSurveyRef) this.$refs.axxSurveyRef.showHideHandle(true);
    },
  },
};
</script>
<style lang="less" scoped>
.surveyBtn{
  padding: 6px 7px;
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  right:80px;
  font-size: 12px;
  border-radius: 8px;
  background: #fff;
  box-shadow: 0px 2px 4px 0px rgba(40, 41, 61, 0.04), 0px 8px 16px 0px rgba(96, 97, 112, 0.16);
  z-index: 10000;
  cursor: pointer;
}
.surveyIcon{
  width: 25px;
  height:25px;
  display: block;
  margin-bottom: 4px;
}
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
